<p><strong [innerHtml]="field.templateOptions.label"></strong></p>

<div>
    <span [innerHtml]="now | date"></span>
</div>